import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { forwardRef, SyntheticEvent } from "react";
import { ControllerRenderProps, ControllerFieldState } from "react-hook-form";

import { Choice } from "types";

export type Props = ControllerRenderProps & {
  id?: string;
  label?: string;
  placeholder?: string;
  helperText?: string;
  choices: Choice[];
  fieldState: ControllerFieldState;
};

export const SelectManyField = forwardRef(
  ({ label, placeholder, helperText, choices, fieldState, ...props }: Props, ref) => {
    const onChange = (event: SyntheticEvent, newValue: string[]) => {
      props.onChange(newValue);
    };

    const handleSelectAll = () => {
      props.onChange(choices);
    };

    const handleClear = () => {
      props.onChange([]);
    };
    const isError = fieldState.invalid && fieldState.isTouched;

    return (
      <Autocomplete
        {...props}
        multiple
        options={choices}
        fullWidth
        disableCloseOnSelect
        disableClearable
        blurOnSelect={false}
        ref={ref}
        aria-required={true}
        onChange={onChange}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        ChipProps={{
          size: "small"
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            helperText={isError ? fieldState.error?.message : helperText}
            error={isError}
            variant="outlined"
          />
        )}
        renderOption={(props, option, { selected }) => {
          return (
            <li {...props}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option.name}
            </li>
          );
        }}
        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              <Box
                onMouseDown={(e) => e.preventDefault()} // prevent blur
                pl={1.5}
                py={0.5}
              >
                <Button variant="text" onClick={handleSelectAll}>
                  select all
                </Button>
                <Button variant="text" onClick={handleClear} disabled={props.value.length === 0}>
                  clear
                </Button>
              </Box>
              <Divider />
              {children}
            </Paper>
          );
        }}
      />
    );
  }
);
